exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mortgage-progress-list[data-v-75b62383] {\n  margin-bottom: 15px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  line-height: 1.5;\n}\n.empty-mortgage-progress[data-v-75b62383] {\n  margin: 15px 0 !important;\n}\n\n", ""]);

// exports
